import { render } from "./DashboardCards.vue?vue&type=template&id=e70f95e0&scoped=true"
import script from "./DashboardCards.vue?vue&type=script&lang=js"
export * from "./DashboardCards.vue?vue&type=script&lang=js"

import "./DashboardCards.vue?vue&type=style&index=0&id=e70f95e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e70f95e0"]])

export default __exports__